angular.module('qkr.merchant.reports')
    .component('merchantreports', {
        template: require('./merchantreports.html')
    });



// WEBPACK FOOTER //
// ./src/reports/merchant/merchantreports.component.js